import { ContentCopy, OpenInNew } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';

import { copyToClipboard } from '@/domain/clipboard/copy-to-clipboard.action';
import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { useAppDispatch } from '@/ui/hook/store';

export function ShowExternalPublicLink({
  invitationPublic,
}: {
  invitationPublic: ExternalInvitation;
}) {
  const dispatch = useAppDispatch();

  const publicLink = buildPublicLink(invitationPublic.code);

  const onClickCopyToClipboard = () => {
    dispatch(copyToClipboard({ text: publicLink }));
  };

  const onClickOpenLink = () => {
    window.open(publicLink);
  };

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        spacing: 1,
      }}
    >
      <FSTextField
        sx={{ maxWidth: 600 }}
        label="Lien public"
        defaultValue={publicLink}
        disabled={true}
      />
      <IconButton onClick={onClickCopyToClipboard}>
        <ContentCopy />
      </IconButton>
      <IconButton onClick={onClickOpenLink}>
        <OpenInNew />
      </IconButton>
    </Stack>
  );
}

function buildPublicLink(code: string) {
  return `${import.meta.env.VITE_BASE_URL}/external/public?code=${code}`;
}
